import { Receipt } from "lucide-react";
import { BillingPortalButton } from "@/components/BillingPortalButton";

export const BillingRow = ({ profile }) => {
  if (!profile || profile.status !== "approved") return null;
  const paidListing = profile.listing_until && profile.listing_until !== profile.free_listing_until;
  if (!paidListing && !profile.featured_until) return null;

  return (
    <div className="silk-card rounded-lg p-4 -mt-4 mb-8 flex flex-wrap items-center justify-between gap-3" data-testid="billing-row">
      <div className="flex items-center gap-3">
        <Receipt size={18} className="text-muted-foreground" />
        <p className="text-xs text-muted-foreground">
          Card expiring? Update your saved card or download invoices for your listing and Featured months.
        </p>
      </div>
      <BillingPortalButton testid="dashboard-billing-portal-btn" />
    </div>
  );
};
